import { css } from '@emotion/react'
import { Cell, Grid, Heading, HFlow, Icon, InfoLabel } from 'bold-ui'
import { InfoIcon } from 'components/InfoIcon'
import { Color } from 'csstype'
import { isUndefinedOrNull } from 'util/checks'
import { formatDate } from 'util/date/formatDate'

interface AcompanhamentoCondicaoSaudeExamesAccordionSectionProps {
  valorExameHemoglobinaGlicada?: string | null
  dataExameHemoglobinaGlicada?: LocalDate | null
  dataSolicitacaoHemoglobinaGlicada?: LocalDate | null
  dataAvaliacaoPes?: LocalDate | null
  iconColor: Color
}

export function AcompanhamentoCondicaoSaudeExamesAccordionSection(
  props: Readonly<AcompanhamentoCondicaoSaudeExamesAccordionSectionProps>
) {
  const {
    valorExameHemoglobinaGlicada,
    dataExameHemoglobinaGlicada,
    dataSolicitacaoHemoglobinaGlicada,
    dataAvaliacaoPes,
    iconColor,
  } = props

  const hasHemoglobinaGlicada =
    !isUndefinedOrNull(valorExameHemoglobinaGlicada) && !isUndefinedOrNull(dataExameHemoglobinaGlicada)

  return (
    <Grid gap={1} gapVertical={0.5} alignItems='baseline'>
      <Cell size={12}>
        <HFlow hSpacing={0.5} alignItems='center'>
          <Icon icon='fileWithItemsFilled' size={1} color={iconColor} />
          <Heading level={4}>Exames</Heading>
        </HFlow>
      </Cell>
      <Cell size={6}>
        <HFlow hSpacing={0.25}>
          <InfoLabel title='Hemoglobina glicada (última avaliação)' titleStyles={styles.title}>
            {hasHemoglobinaGlicada &&
              `${valorExameHemoglobinaGlicada.replace('.', ',')}% em ${formatDate(dataExameHemoglobinaGlicada)}`}
          </InfoLabel>
          <InfoIcon
            icon='infoCircleFilled'
            text={`Exame considerado:
            Dosagem de hemoglobina glicosilada (0202010503)`}
            tooltipStyle={styles.tooltip}
          />
        </HFlow>
      </Cell>
      <Cell size={6}>
        <HFlow hSpacing={0.25}>
          <InfoLabel title='Avaliação dos pés' titleStyles={styles.title}>
            {formatDate(dataAvaliacaoPes)}
          </InfoLabel>
          <InfoIcon
            icon='infoCircleFilled'
            text={`Exame considerado:
            Exame do pé diabético (0301040095)`}
            tooltipStyle={styles.tooltip}
          />
        </HFlow>
      </Cell>
      <Cell size={6}>
        <HFlow hSpacing={0.25}>
          <InfoLabel title='Hemoglobina glicada (última solicitação)' titleStyles={styles.title}>
            {dataSolicitacaoHemoglobinaGlicada && `${formatDate(dataSolicitacaoHemoglobinaGlicada)}`}
          </InfoLabel>
          <InfoIcon
            icon='infoCircleFilled'
            text={`Exame considerado:
            Dosagem de hemoglobina glicosilada (0202010503)`}
            tooltipStyle={styles.tooltip}
          />
        </HFlow>
      </Cell>
    </Grid>
  )
}

const styles = {
  title: css`
    padding-bottom: 0.25rem;
  `,
  tooltip: css`
    max-width: 31rem;
    white-space: pre-line;
  `,
}
